
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platforms/[slug]",
      function () {
        return require("private-next-pages/platforms/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platforms/[slug]"])
      });
    }
  